import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './VerifyAlert.css'
import axios from 'axios';
import FadeLoader from 'react-spinners/FadeLoader'; // Import FadeLoader
import { IoMdClose } from "react-icons/io";
const VerifyAlert = (props) => {
    const { handleShouldapprove, isPopupVisible, BankDetails, Scheduleavailability, CoardinateDetails, Location, searchedLocation, streetName, ...rest } = props;
    const [comment, setComment] = useState('');
    const [error, setError] = useState(''); // State for error message
    const [isLoading, setIsLoading] = useState(false); // State for loading spinner
    const hostPath = process.env.REACT_APP_API_BASE_URL;
    const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);
    const navigate = useNavigate();
    const message = props.isDenyFlow
        ? 'Please confirm denial of this property.'
        : 'Please approve or reject the submission.';

    const handleAcceptReject = (e, val) => {
        e.preventDefault();
        if (comment.trim() === '') {
            setError('Comment cannot be empty');
            return;
        }
        else if (props.parkinglotObj) {
            setError('');
            setIsButtonDisabled(true);
            setIsLoading(true); // Show spinner when request starts
            const lot = props.parkinglotObj;
            const parkinglot = {
                "EmailId": lot.emailId,
                "EntityRegistrationID": lot.entityRegistrationID,
                "ParkingLotAddress": searchedLocation,
                "Parking_Lot_ID": lot.parking_Lot_ID,
                "id": lot.id,
                "CreatedDate": lot.createdDate,
                "CreatedBy": lot?.createdBy,
               Status: props.isDenyFlow
                    ? "Denied"
                    : (val ? "Active" : "Rejected"),
                "Comment": comment,
                "StreetName": streetName,
                VerifyStatus: props.isDenyFlow
                    ? "Denied"
                    : (val ? "Active" : "Rejected"),
                "ApprovedBy": props?.verifiedby,
                "BankDetailID": lot?.bankDetailID,
                "Nickname": lot?.nickName,
                "EmpRegistrationID": props?.empRegistrationId || lot?.empRegistrationID || null,
                // Preserve address fields so full-document update does not null them
                "City": lot?.city ?? lot?.City ?? null,
                "State": lot?.state ?? lot?.State ?? null,
                "Region": lot?.region ?? lot?.Region ?? null,
                "Zipcode": lot?.zipcode ?? lot?.Zipcode ?? null,
                 CoardinateDetails,
                Scheduleavailability
            };
            axios.post(`${hostPath}/api/UpdateParkingLotDetails`, parkinglot, {
                headers: {
                    "x-functions-key": hostHeader
                }
            })
                .then(response => {
                    if (response.data) {
                        e.preventDefault();
                        setIsLoading(false);
                        handleShouldapprove(false, false);
                        navigate('/reviewtab')
                        window.location.reload();
                    }
                })
                .catch(error => {
                    console.error('Error:', error);
                    setIsLoading(false);
                    setIsButtonDisabled(false);
                });
        }
    };
    return (
        <div>
            {isLoading && ( // Show spinner overlay while loading
                <div className="loader-overlay">
                    <FadeLoader />
                </div>
            )}

            {isPopupVisible && !isLoading && ( // Show alert only if not loading
                <div className="alert-overlay">
                    <div className="alert">
                        <div className="close-icon" onClick={() => handleShouldapprove(false, false)}>
                            <IoMdClose />
                        </div>
                        <p>{message}</p>
                        <textarea
                            placeholder="Add your comments here"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                        />
                        {error && <p className="error-message">{error}</p>} {/* Display error message */}
                        <div className="button-container">
                            <button
                                onClick={(e) => handleAcceptReject(e, true)}
                                className='accept-button'
                                disabled={isButtonDisabled}
                            >
                                Approve
                            </button>
                            <button
                                className='reject-button'
                                disabled={isButtonDisabled}
                                onClick={(e) => handleAcceptReject(e, false)}>Reject</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default VerifyAlert;